export const errorNameOf = (error: unknown): string =>
  error instanceof Error ? error.name : typeof error;
